// The time slider works in quarters of an hour: 0 is 00:00, 96 is 24:00

export const timeSlider = {
    min: 0,
    max: 96,
    step: 1,
    // The handles stay more than this many quarters apart (so at least an hour)
    diff: 3
}

const pad = (value: number) => String(value).padStart(2, '0')

/** Slider value (quarters) to 'HH:mm', 96 gives '24:00' */
export function sliderValueToTime(value: number) {
    const hours = Math.floor(value / 4)
    const minutes = Math.round((value - (hours * 4)) * 15)

    return `${pad(hours)}:${pad(minutes)}`
}

/** 'HH:mm' to the slider value (quarters), times between quarters give a fraction */
export function timeToSliderValue(time: string) {
    const [hours, minutes] = time.split(':')

    return (parseInt(hours) * 4) + ((parseInt(minutes) || 0) / 15)
}
